import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { selectors, withOffset } from '@wix/da-shared-react/pkg/Stream';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './AdoptabobblesBought';
import { AppState } from '../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import {
  ADOPTABOBBLES_DEVIATIONS_STREAM_ID,
  ADOPTABOBBLES_DEVIATIONS_STREAM_GROUP_ID,
  ADOPTABOBBLES_PER_FETCH,
} from '../../../streams/adoptabobbles';

type StateProps = Pick<
  Props,
  'isOwner' | 'isEmpty' | 'deviations' | 'isInitialized' | 'isFetching'
>;
type DispatchProps = Pick<Props, 'initFetch'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const streamId = ADOPTABOBBLES_DEVIATIONS_STREAM_ID;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => {
  const normalizedDeviations = selectors.getItems(state, streamId) || [];
  const deviations = getDeviationsByIds(state, normalizedDeviations);

  return {
    deviations,
    isOwner: isCurrentUserProfileOwner(state),
    isEmpty: deviations.length === 0,
    isInitialized: selectors.isInitialized(state, streamId),
    isFetching: selectors.isFetching(state, streamId),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch
) => {
  return {
    initFetch: () => {
      dispatch(
        withOffset.actions.initialize({
          streamId,
          groupId: ADOPTABOBBLES_DEVIATIONS_STREAM_GROUP_ID,
          itemsPerFetch: ADOPTABOBBLES_PER_FETCH,
        })
      );
      dispatch(withOffset.actions.fetch(streamId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
